import gridLayoutReducer from "./gridLayoutReducer";
import notificationReducer from "./notificationReducer";
import stepperReducer from "./stepperReducer";
import userDetailsReducer from "./userReducer";
import formsReducer from "./formsReducer";
import toolbarReducer from "./toolbarReducer";
import flowBuilderReducer from "./flowBuilderReducer";
import pageLayoutReducer from "./pageLayoutReducer";

const reducers = {
  gridLayout: gridLayoutReducer,
  notification: notificationReducer,
  stepper: stepperReducer,
  userDetails: userDetailsReducer,
  forms: formsReducer,
  toolbar: toolbarReducer,
  flowBuilders: flowBuilderReducer,
  pageLayout: pageLayoutReducer,
};

export default reducers;
